var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 998,
    y: 145,
    width: 30,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-998 -145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5433 16.7052C16.8835 17.0357 16.8913 17.5795 16.5608 17.9196 16.555 17.9255 16.5492 17.9314 16.5433 17.9371L15.0685 18.4229 14.8084 18.1628 15.2942 16.688C15.6464 16.3542 16.2004 16.3618 16.5433 16.7052ZM23.2073 7.80311 14.6885 16.3409 13.5938 19.6375 16.9076 18.5443 25.4282 10.0255Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2836 7.17962 26.0517 5.94772C25.7847 5.67461 25.347 5.66959 25.0739 5.93651 25.0701 5.9402 25.0663 5.94394 25.0626 5.94772L23.848 7.1624 26.0517 9.36458 27.266 8.15021C27.5385 7.91051 27.565 7.49535 27.3253 7.22293 27.3121 7.20786 27.2982 7.19339 27.2836 7.17962Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85417 19.6354 12.6398 19.6354 13.0403 18.4271 7.85417 18.4271 7.85417 19.6354Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85417 12.3854 17.3541 12.3854 18.56 11.1771 7.85417 11.1771 7.85417 12.3854Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1458 15.5875 21.1458 24.7708 6.04167 24.7708 6.04167 6.04167 9.36458 6.04167 9.36458 7.85417 17.8229 7.85417 17.8229 6.04167 21.1458 6.04167 21.1458 8.58581 22.5656 7.1624 22.5656 7.1624 22.6173 7.11074 22.9583 6.76969 22.9583 5.4375C22.9583 4.77017 22.4173 4.22917 21.75 4.22917L16.6146 4.22917 16.6146 3.625C16.6146 2.95766 16.0736 2.41667 15.4063 2.41667L11.7812 2.41667C11.1139 2.41667 10.5729 2.95766 10.5729 3.625L10.5729 4.22917 5.4375 4.22917C4.77017 4.22917 4.22917 4.77017 4.22917 5.4375L4.22917 25.375C4.22917 26.0423 4.77017 26.5833 5.4375 26.5833L21.75 26.5833C22.4173 26.5833 22.9583 26.0423 22.9583 25.375L22.9583 13.775ZM12.9485 3.886C13.1192 3.71499 13.3521 3.62077 13.5938 3.625 14.0943 3.625 14.5 4.03073 14.5 4.53125 14.5 5.03177 14.0943 5.4375 13.5938 5.4375 13.0932 5.4375 12.6875 5.03177 12.6875 4.53125 12.6833 4.28964 12.7775 4.05671 12.9485 3.886Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 145)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85417 16.0104 13.7291 16.0104 14.935 14.8021 7.85417 14.8021 7.85417 16.0104Z",
    fill: "#004E97",
    transform: "matrix(1.03448 0 0 1 998 145)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDraft);
export default __webpack_public_path__ + "static/media/IconDraft.cf1f72d79688c0ad0475bed0e62cf302.svg";
export { ForwardRef as ReactComponent };